
export interface IDictionary<T> {
    [index: string]: T;
}

export class AppSettings implements IDictionary < string > {
    [index: string]: string;
}

